import messageCategory from "../constants/message-category";
import { isFinnish } from "./culture-helper";

const ssnCategoriesFinland: string[] = [
  messageCategory.Estate,
  messageCategory.PersonalInjuryClaim,
  messageCategory.PersonalInjuryInTrafficClaim,
  messageCategory.TravelInjuryClaim,
  messageCategory.TravelInterruptionClaim,
];

const centuryLookup: Record<string, string> = {
  "+": "18",
  "-": "19",
  Y: "19",
  X: "19",
  W: "19",
  V: "19",
  U: "19",
  A: "20",
  B: "20",
  C: "20",
  D: "20",
  E: "20",
  F: "20",
};

const regexFinland = new RegExp(
  "^[0-3][0-9][0-1][0-9]{3}[-+YXWVUABCDEF][0-9]{3}[A-z0-9]$",
);
const controlSignValues = "0123456789ABCDEFHJKLMNPRSTUVWXY";

const showSSNField = (
  cultureCode: string | null | undefined,
  category: string,
): boolean => {
  if (isFinnish(cultureCode)) {
    return ssnCategoriesFinland.includes(category);
  }

  return false;
};

const ssnIsValid = (
  cultureCode: string | null | undefined,
  ssn: string,
): boolean => {
  if (isFinnish(cultureCode)) {
    return ssnIsValidFinland(ssn);
  }

  return false;
};

const ssnIsValidFinland = (ssn: string): boolean => {
  if (!regexFinland.test(ssn)) {
    return false;
  }

  return dateAndValueCheckFinland(ssn);
};

const dateAndValueCheckFinland = (ssn: string): boolean => {
  const day = ssn.substring(0, 2);
  const month = ssn.substring(2, 4);
  const year = ssn.substring(4, 6);
  const centurySign = ssn.substring(6, 7);
  const controlNumber = ssn.substring(7, 10);
  const controlSign = ssn.substring(10, 11);

  const century = centuryLookup[centurySign];
  if (!century) {
    return false;
  }

  const yearWithCentury = century + year;
  const date = `${yearWithCentury}/${month}/${day}`;

  if (isNaN(Date.parse(date))) {
    return false;
  }

  const checkValue = Number(`${day}${month}${year}${controlNumber}`);
  const controlSignIndex = checkValue % 31;
  const calculatedControlSign = controlSignValues.charAt(controlSignIndex);

  return controlSign === calculatedControlSign;
};

export { showSSNField, ssnIsValid };
